module.exports = __webpack_public_path__ + "static/media/vf_mouter_core.f6350b45.svg";